/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useStore } from '../../../store';
import { IListsForReport } from '../../../store/modules/report/i-report';
import checkPermission from '../../../utils/permissions/permissions';
import { useActions } from '../../providers/actions-provider/actions.context';

import ReportParams from './report-params';

const ThirdTab = ({
  regex,
  quickRanges: reportQuickRanges,
  operators,
  filterFields,
}: IListsForReport): JSX.Element => {
  const { location: { pathname } } = useHistory();
  const positionOfExec = pathname.indexOf('exec-');
  const positionOfID = pathname.indexOf('/', positionOfExec + 5);
  const id = pathname
    .slice(positionOfExec + 5, positionOfID === -1 ? pathname.length : positionOfID);
  const { reportActions } = useActions();
  const {
    executedReport,
  } = useStore();

  useEffect(() => {
    if (!executedReport.loaded) {
      reportActions.getExecutedReport(+id);
    }
  }, []);

  const onSubmitAction = (find: string, sort: string) => {
    async function executeAction() {
      await reportActions.updateExecutedReport(+id, {
        id: +id,
        tenant: executedReport.data.tenant,
        description: executedReport.data.description,
        columns: executedReport.data.columns,
        name: executedReport.data.name,
        code: executedReport.data.code,
        collection: executedReport.data.collection,
        aggregate: executedReport.data.aggregate,
        find,
        sort,
      });
      await reportActions.getExecutedReport(+id);
    }
    executeAction();
  };

  return (
    <ReportParams
      regex={regex}
      quickRanges={reportQuickRanges}
      operators={operators}
      filterFields={filterFields}
      submitButtonLabel="Save"
      notEditable={!checkPermission('reports', 'write')}
      onSubmitAction={onSubmitAction}
      submitButtonAlwaysEnabled={false}
      filtersString={executedReport.data.find || ''}
      sortsString={executedReport.data.sort || ''}
      reportColumns={executedReport.data.columns}
      reportCollection={executedReport.data.collection}
    />
  );
};

ThirdTab.displayName = 'ThirdTab';
export default ThirdTab;
